import React from "react";
import { Link as RouterLink } from 'react-router-dom';
// import labill1 from './../assets/img/Illustrations/Laboratory-amico.svg';
// import fastDep from './../assets/img/Illustrations/Setup-amico.svg';
import dots from './../assets/img/Illustrations/Dots.png';
// import newP from './../assets/img/Illustrations/lims_landing_hero.png';
import DownloadBrochure from './DownloadBrochure';
import saas_main from '../assets/img/Illustrations/saas_main.png';
import saas_sub from '../assets/img/Illustrations/saas_sub.png';
import feature_1 from '../assets/img/budget.png';
import feature_2 from '../assets/img/Compliance.png';
import feature_3 from '../assets/img/Rocket.png';
import feature_4 from '../assets/img/People.png';
import feature_5 from '../assets/img/Security.png';
import feature_6 from '../assets/img/Graph.png';
import Faq from './Faq';


const SaaS = () => {
    
    return (<div className='portifoliobody' id="SAAS">
        <main id="main">
            <section className="about text-start" style={{paddingTop:'60px'}}>
                {/* <div className="section-title text-center" data-aos="zoom-out">
                    <h1 style={{ fontWeight: 'bold',color:'rgba(4,52,111)'}}>LAB ICONICS LIMS</h1>
                </div> */}
                <div className='landing-page'>
                    <div>
                        <div className="landing-title carousel-container animate__animated animate__fadeInLeft" data-aos="fade-left" data-aos-delay="100">
                            <h1>Lab Iconics LIMS-ELN (SaaS Model) The Smart, Scalable, and Secure Solution</h1>
                            <div style={{width:'82%'}}>
                                <p>
                                Lab Iconics LIMS-ELN SaaS Model provides a cost-effective, scalable LIMS without the need for any IT infrastructure. With a pay-as-you-go model, labs can control costs and scale easily. Our cloud-based platform reduces expenses and enables quick deployment within 48 hours, allowing labs to focus on their work without any hassles.
                                </p>
                            </div>
                            {/* <div className='landing-book-a-demo-div'>
                                <RouterLink to='/demo' href='#REQUEST A DEMO' className='routerLink'>
                                    <div className='landing-book-a-demo-btn'>
                                        Get a Demo
                                    </div>
                                </RouterLink>
                            </div> */}
                            <div className="book_a_demo product-demo" style={{padding:'1rem 1rem 0 0'}}>
                                <RouterLink to='/saas-form'> 
                                    <button className="book_a_demo_btn product-demo-btn">Subscribe</button>
                                </RouterLink>
                            </div>
                        </div>
                        {/* <div className="left-img" style={{bottom:'-60%'}}>
                            <img src={dots} alt="" />
                        </div> */}
                        <div className="landing-img-div landing-img-div-saas carousel-container col-12 col-lg-6 animate__animated animate__fadeInRight" data-aos="fade-right" data-aos-delay="100">
                            <img src={saas_sub} alt="" />
                        </div>
                    </div>
                </div>

                <div className="section-container" style={{margin:'0px'}}>
                    <div className="row">
                        <div className="section-pro">
                            <div className="sec-out">
                                <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100">
                                    <img src={saas_main} alt=""/>
                                </div>  
                                <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                    <div className="sec-title"><h1>Lab Iconics LIMS-ELN SaaS – Powering the Future of Smart Labs</h1></div>
                                    <ul>
                                        <li>Lab Iconics LIMS-ELN  SaaS Model enhances throughput and efficiency by streamlining sample tracking, workflow automation, and data management. It reduces errors, optimizes resources, and accelerates turnaround time. With an intuitive, metadata-driven interface, labs can quickly configure workflows, minimizing onboarding time and maximizing productivity and accuracy in operations.</li>
                                        <li>Lab Iconics LIMS-ELN SaaS Model ensures data security and compliance with end-to-end encryption, audit trails, and tamper-proof records. Fully compliant with ISO:17025 and 21 CFR Part 11, it enables seamless audits, automated documentation, and real-time compliance checks to protect data integrity.</li>
                                        <li>An integrated LIMS-ELN SaaS model centralizes lab operations with shared inventories, ensuring seamless sample tracking, data integrity, and collaboration while reducing redundancy, enhancing compliance, and streamlining workflows for efficiency.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="services">
                    <div className="container services mt-5" >
                        <div className="row">
                            <div className="section-title text-center" data-aos="zoom-out">
                                <h1 style={{ fontWeight: 'bold', color: 'rgba(4,52,111)' }}>KEY FEATURES</h1>
                            </div>

                            <div className="col-lg-6 col-md-6 mt-5">
                                <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                                    <div className="icon"><i><img alt='' src={feature_1} style={{ width: '50px' }} /></i></div>
                                    <h4 className="title" style={{ color: 'rgba(4,52,111)'}}><a>Budget-Friendly </a></h4>
                                    <p className="description">Experience the power of a fully featured, cost-effective LIMS with Lab Iconics SaaS. Our cloud-based model helps you cut IT infrastructure costs, eliminate expensive upgrades, and stay within budget all while ensuring seamless lab operations. Get enterprise-grade functionality without the hefty price tag.</p>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 mt-5">
                                <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                                    <div className="icon ml-5"><i><img alt='' src={feature_3} style={{ width: '50px' }} /></i></div>
                                    <h4 className="title" style={{ color: 'rgba(4,52,111)' }}><a >Lightning-Fast Deployment – Go Live in Under 48 hours!  </a></h4>
                                    <p className="description">Our fully validated, pre-configured SaaS LIMS ensures rapid deployment in less than 48 hours. Simply upload your metadata, and you’ll have your system up and running fast, efficient, and hassle free.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 mt-5">
                                <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                                    <div className="icon"><i><img alt='' src={feature_6} style={{ width: '50px' }} /></i></div>
                                    <h4 className="title" style={{ color: 'rgba(4,52,111)' }}><a>Boost Efficiency with Faster Throughput </a></h4>
                                    <p className="description"> Optimize sample management and workload distribution to bring order to the chaos. With Lab Iconics SaaS LIMS, streamline the operations enables more time to focus on what matters most.</p>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 mt-5">
                                <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                                    <div className="icon ml-5"><i><img alt='' src={feature_5} style={{ width: '50px' }} /></i></div>
                                    <h4 className="title" style={{ color: 'rgba(4,52,111)' }}><a >Uncompromised Data Integrity & Security </a></h4>
                                    <p className="description">Protect your critical lab data with built-in compliance, secure access controls, and automated audit trails. Lab Iconics SaaS LIMS ensures data integrity, confidentiality, and regulatory compliance, keeping your information safe, traceable, and tamper-proof throughout the life cycle.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 mt-5">
                                <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                                    <div className="icon"><i><img alt='' src={feature_2} style={{ width: '50px' }} /></i></div>
                                    <h4 className="title" style={{ color: 'rgba(4,52,111)' }}><a >Compliance Ready </a></h4>
                                    <p className="description"> Stay ahead of regulations with a fully compliant LIMS that meets ISO 17025, 21 CFR Part 11, and other regulatory standards. Lab Iconics SaaS LIMS ensures audit readiness, data integrity, and effortless regulatory compliance, giving you a peace of mind.</p>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 mt-5">
                                <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                                    <div className="icon ml-5"><i><img alt='' src={feature_4} style={{ width: '50px' }} /></i></div>
                                    <h4 className="title" style={{ color: 'rgba(4,52,111)' }}><a >Anywhere Access & Seamless Collaboration. </a></h4>
                                    <p className="description"> Empower your team with secure, remote access to lab data anytime, anywhere. Lab Iconics SaaS LIMS enables real-time collaboration, ensuring teams across locations can share insights, track progress, and streamline workflows effortlessly.</p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="subscribe-div" data-aos="fade-up" data-aos-delay="200">
                        <RouterLink className='sub-today routerLink' to='/saas-form' >Subscribe today</RouterLink>
                    </div>
                    
                </div>

            </section>
        </main>
        <div className="down-broch" data-aos="fade-up">
            <DownloadBrochure product={'SAAS'}/>
        </div>
        <div data-aos="fade-up">
            <Faq product={'SAAS'}/>
        </div>

        {/* <svg className="hero-waves" style={{ background: 'rgba(4,52,111)' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28" preserveAspectRatio="none">
            <defs>
                <path id="wave-path" d="M-160 44c30 0 58-18 88-18s58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
            </defs>
            <g className="wave1">
                <use xlinkHref="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
            </g>
            <g className="wave2">
                <use xlinkHref="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
            </g>
            <g className="wave3">
                <use xlinkHref="#wave-path" x="50" y="9" fill="#fff" />
            </g>
        </svg> */}
    </div>

    );
}

export default SaaS